export const LEADLOOP_FACEBOOK_CLIENT_ID = '473455796623385';
export const LEADLOOP_NYLAS_CLIENT_ID = '546uurrvnpwsqsly8opge7b1p';
